import axios from 'axios';
import localStorage from '../../services/storage';
import { store } from '../../store/store';
import userActions from "./userActions";
import { transformErrors } from '@checkout/services/errors';

// Before each ajax request activate preloader screen
axios.interceptors.request.use((configAxios) => {
    configAxios.headers.common.locale = localStorage.get('locale', true);
    return configAxios;
});

export default {
    /**
     * Store user from step 5
     *
     * @param state
     * @param payload
     * @return  {void}
     */
    storeUser({ commit }, payload) {
        commit('STORE_USER', payload);
    },

    /**
     * Attempts to login a user via MSISDN login type
     *
     * @param   {Object}  state
     * @param   {Object}  commit
     * @param   {Object}  authData
     */
    attemptToGetSmsCodeViaMsisdn({ commit }, authData) {
        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

        const params = new URLSearchParams();
        params.append('phone', authData.phone);
        params.append('token', authData.token);
        return axios.post(`/public-api/send-sms`, params)
            .then((response) => {
                const isSmsCodeSent = response.data.code === 'SEND_SMS_TO_USER_SUCCESS';
                store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                commit('SET_SMS_CODE', {
                    userId: response.data.body.user.userId,
                    isSmsCodeSent,
                    phoneNumber: response.data.body.user.phoneNumber,
                });
            });
    },

    /**
     * Attempts to login a user via Sms code login type
     *
     * @param {object} commit
     * @param {object} authData
     */
    loginViaSms({ commit }, authData) {
        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

        const params = new URLSearchParams();
        params.append('id', authData.userId);
        params.append('code', authData.code);
        return axios.post(`/public-api/sms-login`, params)
            .then((response) => {
                store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                localStorage.save('token', response.data.body.token, true);
                return userActions.getMe(commit, response.data.body.token)
            });
    },

    /**
     * Attempts to login a username and passowrd
     *
     * @param {object} commit
     * @param {object} authData
     */
    loginViaPassword({ commit }, authData) {
        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

        const params = new URLSearchParams();
        params.append('username', authData.username);
        params.append('password', authData.password);
        params.append('token', authData.token);
        return axios.post(`/public-api/password-login`, params)
            .then((response) => {
                store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                localStorage.save('token', response.data.body.token, true);
                return userActions.getMe(commit, response.data.body.token);
            });
    },

    /**
     * Password reset 
     *
     * @param {object} commit
     * @param {object} data
     */
    passwordReset({ commit }, data) {
        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

        const params = new URLSearchParams();
        params.append('username', data.username);
        params.append('token', data.token);
        return axios.post(`/public-api/password-reset`, params)
            .then((response) => {
                store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                return response;
            });
    },

    /**
     * Get Me
     *
     * @param {object} commit
     * @param {string} token
     */
    getMe(commit, token) {
        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

        return axios.post('/public-api/me', {token: token}).then((response) => {
            const user = response.data.user.body.user;
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

            return user;
        })
            .catch((error) => {
                store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                if (error.response.status === 422) {
                    this.errors = transformErrors(error.response.data.errors);
                }
            });
    },
};
